export default "__VITE_ASSET__008af91a__"